/**
 * Cart Loading State - Skeleton loaders matching card layouts
 */
import { Skeleton } from '@/components/ui/skeleton';
import { Separator } from '@/components/ui/separator';

export function CartLoadingState() {
  return (
    <div className="space-y-4 p-4" data-testid="cart-loading-state">
      {/* Item skeletons */}
      {[1, 2].map((i) => (
        <div key={i} className="space-y-3">
          <div className="flex gap-3">
            <Skeleton className="h-20 w-20 rounded-lg" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-3 w-1/2" />
              <Skeleton className="h-3 w-2/3" />
            </div>
            <Skeleton className="h-8 w-8 rounded-md" />
          </div>
          <Separator />
        </div>
      ))}
      
      {/* Summary skeleton */}
      <div className="space-y-2 pt-4">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-6 w-full" />
      </div>
    </div>
  );
}
